var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgImgWaveBackground = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 1440,
  height: 170,
  viewBox: "0 0 1440 170",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1440 32.9505V170.614H0V22.6618C45.6078 20.2177 91.0892 16.8394 136.571 13.4612C227.838 6.68205 319.105 -0.0970733 411.393 0.674428C500.122 1.41549 588.79 17.5666 677.181 33.6663C746.202 46.2382 815.053 58.7788 883.632 63.9279C1052.73 76.6277 1144.91 64.5185 1235.93 52.5624C1280.44 46.714 1324.68 40.9029 1377.5 38.0492C1398.72 36.9028 1419.51 35.1493 1440 32.9505Z"
})));
export default SvgImgWaveBackground;